import processingMarkApplicationReducer from "./markApplicationReducer";

const processingMarkApplicationReducers = {
    processingMarkApplication: processingMarkApplicationReducer
}

export default processingMarkApplicationReducers